export const acceptLanguageMap: Record<string, AcceptLanguage> = {
  en: 'en-US',
  hr: 'hr-HR',
  hu: 'hu-HU',
  sk: 'sk-SK',
};

export type AcceptLanguage = 'en-US' | 'hr-HR' | 'hu-HU' | 'sk-SK';
